export enum CLIENT_USER_ROLE {
  OWNER = 'OWNER',
  FULL_MEMBER = 'FULL_MEMBER',
  MEMBER = 'MEMBER',
}

export enum CLIENT_USER_STATUS {
  INVITED = 'INVITED',
  ACTIVE = 'ACTIVE',
  PENDING_DELETION = 'PENDING_DELETION',
  REVOKED = 'REVOKED',
}

export enum CLIENT_USER_INVITATION_TYPE {
  SIGN_UP = 'SIGN_UP',
  CLIENT_INVITED = 'CLIENT_INVITED',
  ADMIN_INVITED = 'ADMIN_INVITED',
  PARTNER_INVITED = 'PARTNER_INVITED',
}

export enum CLIENT_USER_MEMBER_TYPE {
  PRIMARY = 'PRIMARY',
  SECONDARY = 'SECONDARY',
}

export interface UserAccess {
  submoduleId: string;
  submoduleType: string;
  submoduleName: string;
}

export interface ClientUser {
  membershipGrantId: string;
  userId: string;
  email: string;
  username?: string;
  companyRole: CLIENT_USER_ROLE;
  status: CLIENT_USER_STATUS;
  invitationType: CLIENT_USER_INVITATION_TYPE;
  invitedBy?: string;
  memberType?: CLIENT_USER_MEMBER_TYPE;
  userAccesses: UserAccess[];
}

export interface ClientUsersListResponse {
  totalPages: number;
  totalElements: number;
  items: ClientUser[];
  metadata: null;
}

export type InviteUserPayload = {
  clientCode: string;
  email: string;
  username: string;
  companyRole: CLIENT_USER_ROLE;
  submoduleIds?: string[] | null;
};

export type UpdateUserAccessPayload = {
  clientCode: string;
  membershipGrantId: string;
  companyRole: CLIENT_USER_ROLE;
  submoduleIds?: string[] | null;
};

export type RevokeUserAccessPayload = {
  clientCode: string;
  membershipGrantId: string;
};

export interface Clients {
  id: string;
  name: string;
  clientCode: string;
  address: string;
  companyHQ: string;
}

export interface PendingAccessRequest {
  requestId: string;
  userId: string;
  email: string;
  username: string;
  requestedAt: string;
  expiresInDays: number;
  status: string;
  grantedRole: CLIENT_USER_ROLE | null;
}

export type AcceptAccessRequestPayload = {
  clientCode: string;
  requestId: string;
  companyRole: CLIENT_USER_ROLE;
  submoduleIds?: string[] | null;
};

export type RejectAccessRequestPayload = {
  clientCode: string;
  requestId: string;
};
